import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasApprovedExpertAccess } from "@/lib/expertAccess";
import DeleteAccountSection from "@/components/account/DeleteAccountSection";

export default function ExpertAccountSettings() {
  const { user } = useAuth();

  if (hasApprovedExpertAccess(user)) return <Navigate to="/expert?tab=settings" replace />;
   return (
    <main className="min-h-screen bg-brand-wash">
      <div className="max-w-2xl mx-auto px-4 py-8 sm:py-12">
        <div className="font-mono uppercase text-[11px] tracking-widest text-brand-muted">Konto</div>
        <h1 className="font-display text-3xl font-bold text-brand-ink">Indstillinger</h1>
        <div className="mt-6 card-outline bg-white p-5 sm:p-6">
          <div className="text-sm font-medium text-brand-ink">E-mail</div>
          <div className="mt-1 text-sm text-brand-body">{user?.email}</div>
          <p className="mt-4 text-sm text-brand-muted">Din ekspertadgang aktiveres automatisk, når profilen er godkendt.</p>
          <Link to="/expert/afventer-godkendelse" className="btn-secondary inline-flex mt-5">Se profilstatus</Link>
        </div>
        <div className="mt-6"><DeleteAccountSection/></div>
      </div>
    </main>
  );
}

